'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var StoreContext = React__default['default'].createContext();
var StoreProvider = function StoreProvider(_ref) {
  var children = _ref.children,
      onFinish = _ref.onFinish,
      onForward = _ref.onForward;

  var _useState = React.useState(0),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      currentStep = _useState2[0],
      setCurrentStep = _useState2[1];

  var _useState3 = React.useState(new Set()),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      checkedSteps = _useState4[0],
      setCheckedSteps = _useState4[1];

  var _useState5 = React.useState(null),
      _useState6 = _rollupPluginBabelHelpers.slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var steps = React__default['default'].Children.toArray(children.props.children).map(function (_ref2) {
    var _ref2$props = _ref2.props,
        id = _ref2$props.id,
        title = _ref2$props.title;
    return {
      id: id,
      title: title,
      formRef: React.useRef(null)
    };
  });
  var isFirstStep = currentStep === 0;
  var isLastStep = currentStep === steps.length - 1;

  var onCloseError = function onCloseError() {
    return setError(null);
  };

  var onNavigateToStep = function onNavigateToStep(index, force) {
    if (index > currentStep && isLastStep) {
      onFinish();
    } else if (force || checkedSteps.has(index) || checkedSteps.has(index - 1)) {
      setCurrentStep(index);
    }
  };

  var onGoBack = function onGoBack() {
    return onNavigateToStep(currentStep - 1);
  };

  var onGoForward = function onGoForward() {
    if (steps[currentStep].formRef.current) {
      steps[currentStep].formRef.current.dispatchEvent(new Event('submit'));
    }
  };

  var handleWizardSubmit = /*#__PURE__*/function () {
    var _ref3 = _rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var name, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return onForward({
                step: currentStep,
                data: data
              });

            case 3:
              setCheckedSteps(function (current) {
                return new Set([].concat(_rollupPluginBabelHelpers.toConsumableArray(current), [currentStep]));
              });
              onNavigateToStep(currentStep + 1, true);
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              name = _context.t0.name;
              message = _context.t0.message;
              setError({
                name: name,
                message: message
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function handleWizardSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(StoreContext.Provider, {
    value: {
      checkedSteps: checkedSteps,
      currentStep: currentStep,
      error: error,
      handleWizardSubmit: handleWizardSubmit,
      isFirstStep: isFirstStep,
      isLastStep: isLastStep,
      onCloseError: onCloseError,
      onGoBack: onGoBack,
      onGoForward: onGoForward,
      onNavigateToStep: onNavigateToStep,
      steps: steps
    }
  }, children);
};
StoreProvider.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  onFinish: PropTypes__default['default'].func.isRequired,
  onForward: PropTypes__default['default'].func.isRequired
};

exports.StoreProvider = StoreProvider;
exports.default = StoreContext;
